






























































































import Vue from 'vue';
import { EntranceEntity, GetCurrentScanningLocationOptions } from '../../../types';

export default Vue.extend({
  name: 'scan',
  data() {
    return {
      selectedEntrance: null as number | null,
      noStreamApiSupport: false,
    };
  },
  async created() {
    (this as any).startLoading();

    (this as any).updateQueryParameters();

    await (this as any).setInitialValues();

    (this as any).stopLoading();
  },
  async mounted() {
    if (!(this as any).currentLocationSecurityScanningCode || !(this as any).currentLocationId || !(this as any).apiKey) {
      this.$store.commit('appData/REMOVE_LOGIN_DATA');

      this.$router.push({ name: 'login' });
    }

    this.selectedEntrance = (this as any).currentLocationEntranceId || (this.validEntrances[0] && this.validEntrances[0].id) || null;
  },
  computed: {
    validEntrances(): EntranceEntity[] {
      return (this as any).entrances;
    },
  },
  methods: {
    onDecode(qrCode: string): void {
      if (qrCode.length > 0) {
        this.$router.push({
          name: 'response',
          params: {
            qrCode,
          },
        });
      }
    },
    logErrors(promise: any): void {
      promise.catch(console.error);
    },
    async onInit(promise: any) {
      try {
        await promise;
      } catch (error) {
        if (
          [
            'NotFoundError',
            'StreamApiNotSupportedError',
            'NotAllowedError',
            'NotSupportedError',
            'NotReadableError',
            'OverconstrainedError',
            'InsecureContextError',
          ].includes(error.name)
        ) {
          this.noStreamApiSupport = true;
        }
      }
    },
    async forceUpdateLocationData(): Promise<void> {
      const options: GetCurrentScanningLocationOptions = {
        apiKey: (this as any).apiKey,
        customerId: (this as any).customerId,
        locationId: (this as any).currentLocationId,
        securityScanningCode: (this as any).currentLocationSecurityScanningCode,
      };

      await this.$store.dispatch('appData/GET_CURRENT_SCANNING_LOCATION', options);

      (this as any).hideLoader();
    },
  },
  watch: {
    validEntrances(newVal) {
      this.selectedEntrance = (this as any).currentLocationEntranceId || (this.validEntrances[0] && this.validEntrances[0].id) || null;
    },
    selectedEntrance(newVal) {
      if (newVal !== (this as any).currentLocationEntranceId) {
        this.$store.commit('appData/SET_CURRENT_SCANNING_LOCATION_ENTRANCE', newVal);
      }
    },
  },
});
